module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('div', {
    staticClass: "control"
  }, [_c('b-switch', {
    model: {
      value: (_vm.showDetailIcon),
      callback: function($$v) {
        _vm.showDetailIcon = $$v
      },
      expression: "showDetailIcon"
    }
  }, [_vm._v("Show detail icon")])], 1)]), _vm._v(" "), _c('b-table', {
    ref: "table",
    attrs: {
      "data": _vm.data,
      "paginated": "",
      "per-page": "5",
      "opened-detailed": _vm.defaultOpenedDetails,
      "detailed": "",
      "detail-key": "id",
      "show-detail-icon": _vm.showDetailIcon,
      "aria-next-label": "Next page",
      "aria-previous-label": "Previous page",
      "aria-page-label": "Page",
      "aria-current-label": "Current page"
    },
    on: {
      "details-open": function (row, index) { return _vm.$buefy.toast.open(("Expanded " + (row.user.first_name))); }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "field": "id",
            "label": "ID",
            "width": "40",
            "numeric": ""
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.id) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "user.first_name",
            "label": "First Name",
            "sortable": ""
          }
        }, [(_vm.showDetailIcon) ? [_vm._v("\n                        " + _vm._s(props.row.user.first_name) + "\n                    ")] : [_c('a', {
          on: {
            "click": function($event) {
              _vm.toggle(props.row)
            }
          }
        }, [_vm._v("\n                            " + _vm._s(props.row.user.first_name) + "\n                        ")])]], 2), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "user.last_name",
            "label": "Last Name",
            "sortable": ""
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.user.last_name) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "date",
            "label": "Date",
            "sortable": "",
            "centered": ""
          }
        }, [_c('span', {
          staticClass: "tag is-success"
        }, [_vm._v("\n                        " + _vm._s(new Date(props.row.date).toLocaleDateString()) + "\n                    ")])]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Gender"
          }
        }, [_c('span', [_c('b-icon', {
          attrs: {
            "pack": "fas",
            "icon": props.row.gender === 'Male' ? 'mars' : 'venus'
          }
        }), _vm._v("\n                        " + _vm._s(props.row.gender) + "\n                    ")], 1)])]
      }
    }, {
      key: "detail",
      fn: function(props) {
        return [_c('article', {
          staticClass: "media"
        }, [_c('figure', {
          staticClass: "media-left"
        }, [_c('p', {
          staticClass: "image is-64x64"
        }, [_c('img', {
          attrs: {
            "src": "/static/img/placeholder-128x128.png"
          }
        })])]), _vm._v(" "), _c('div', {
          staticClass: "media-content"
        }, [_c('div', {
          staticClass: "content"
        }, [_c('p', [_c('strong', [_vm._v(_vm._s(props.row.user.first_name) + " " + _vm._s(props.row.user.last_name))]), _vm._v(" "), _c('small', [_vm._v("@" + _vm._s(props.row.user.first_name))]), _vm._v(" "), _c('small', [_vm._v("31m")]), _vm._v(" "), _c('br'), _vm._v("\n                                Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n                                Proin ornare magna eros, eu pellentesque tortor vestibulum ut.\n                                Maecenas non massa sem. Etiam finibus odio quis feugiat facilisis.\n                            ")])])])])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05c4aab8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/table/examples/ExDetailedRow.vue
// module id = 1211
// module chunks = 1 58